import { useState } from 'react';
import { Routing } from '../Routes';
import { Main } from '../Main/Main';
import { useTranslation } from '../../i18n/i18n';
import { useConfig } from '../../config';
import axios from 'axios';
import { AlertMessages, useAlerts } from '../AlertMessages/AlertMessages';
import { useSession } from '../../state/session';
import { ApiActionResponse } from '../../types';
import { useHistory } from 'react-router-dom';
import { Button } from '../../components/Form/Button';
import { MessagesContainer } from '../../state/messages';
import { TextInput } from '../Form/TextInput';
import { ContentCard } from '../ContentCard/ContentCard';
import { TextArea } from '../Form/TextArea';
import { onKeyPress } from '../Form/PressedEnter';

const axiosConf = { withCredentials: true };

type DeleteAccount = {
	reason: string;
	password: string;
};

export const DeleteAccountPage = (): JSX.Element => {
	const t = useTranslation().deleteAccount;
	const alert = MessagesContainer.useContainer();
	const { logout } = useSession();
	const history = useHistory();
	const { api } = useConfig();
	const passwordAlerts = useAlerts();
	const [reason, setReason] = useState('');
	const [password, setPassword] = useState('');

	const deleteAccount = {
		reason: reason,
		password: password,
	};

	async function signout() {
		if (await logout()) {
			history.push('/');
		}
	}

	async function handleSubmit() {
		const payload: DeleteAccount = deleteAccount;
		passwordAlerts.clear();
		if (password.length < 5) {
			passwordAlerts.set({ type: 'error', message: t.tooShortPassword });
		} else {
			const res = await axios.post<ApiActionResponse>(`${api}me/delete-account.json`, payload, axiosConf);

			if (res.data.success) {
				alert.add({ type: 'success', message: t.weHaveSentAnEmail });
				signout();
			} else {
				passwordAlerts.set({ type: 'error', message: t.wrongPassword });
				setPassword('');
			}
		}
	}

	return (
		<Main>
			<ContentCard title={t.deleteAccount}>
				<p>{t.ifYOuWantToRemove}</p>
				<p>{t.whenWeReceived}</p>
				<div className="delete-form">
					<AlertMessages alerts={passwordAlerts} />
					<TextArea
						placeholder={t.tellWhy}
						value={reason}
						onChange={(e) => setReason(e.target.value)}
						autoFocus={true}
						onKeyDown={onKeyPress}
						nextElement="delete-password"
					/>
					<TextInput
						type="password"
						id="delete-password"
						placeholder={t.password}
						value={password}
						onChange={(e) => setPassword(e.target.value)}
						onKeyDown={onKeyPress}
					/>
					<div className="card-footer">
						<Button onClick={handleSubmit}>{t.deleteAccount}</Button>
						<Button className="secondary" onClick={() => history.push('/')}>
							{t.cancel}
						</Button>
					</div>
				</div>
			</ContentCard>
		</Main>
	);
};

export const deleteAccountRouting: Routing = {
	path(urls) {
		return urls.removeAccount;
	},
	component: DeleteAccountPage,
	requiresAuth: true,
};
